import { Badge, Flex, Text } from "@chakra-ui/react";
import type {
  APIListingAgentUpdateEntry,
  APIListingApplicantFeedbackEntry,
  APIListingEventFeedbackEntry,
} from "models/types/api-listing";
import { useFormatMoney } from "hooks/use-format-money";

export function getFeedbackHeaderText(
  feedback:
    | APIListingApplicantFeedbackEntry
    | APIListingAgentUpdateEntry
    | APIListingEventFeedbackEntry,
) {
  if (feedback.type.id === "agent_vendor") {
    return feedback.agent.name;
  }

  if (feedback.type.id === "price_reduction") {
    const price = feedback as APIListingAgentUpdateEntry;
    return price.details
      ? "Price change from " +
          price.details.previous_advertising +
          " to " +
          price.details.new_advertising
      : "Price change";
  }

  if ("attendees" in feedback && feedback.attendees?.length) {
    return (
      feedback.attendees
        .map((attendee) => attendee.contact.name)
        .join(", ")
        //replace final comma with "and"
        .replace(/, ([^,]*)$/, " and $1")
    );
  }

  return feedback.agent.name + " (Agent)";
}

type FeedbackHeaderProps = {
  feedback:
    | APIListingApplicantFeedbackEntry
    | APIListingAgentUpdateEntry
    | APIListingEventFeedbackEntry;
  isNew?: boolean;
};

export function FeedbackHeader({ feedback }: FeedbackHeaderProps) {
  const formatMoney = useFormatMoney();
  return (
    <Flex direction={"row"} align={"center"} gap={2}>
      <Flex gap={2} flex={1} align={"center"}>
        <Text textStyle={"large"} fontWeight={"semibold"} color={"gray.700"}>
          {getFeedbackHeaderText(feedback)}
        </Text>
        {"is_new" in feedback && feedback.is_new ? (
          <Badge colorScheme={"badgeLightBlue"}>NEW</Badge>
        ) : null}
      </Flex>
      {feedback.type.id === "offer" &&
        "price_indication" in feedback &&
        feedback.price_indication && (
          <Text
            textStyle={"large"}
            fontWeight={"semibold"}
            color={"gray.700"}
            alignItems={"flex-end"}
          >
            {formatMoney(feedback.price_indication)}
          </Text>
        )}
    </Flex>
  );
}
